// unbiased random integer in [0, max) via crypto.getRandomValues (avoids Math.random(),
// which isn't cryptographically secure) - max must fit within 32 bits
export const secureRandomInt = (max = 0xFFFFFFFF) => {
  const range = Math.floor(0x100000000 / max) * max
  let rand
  do {
    rand = crypto.getRandomValues(new Uint32Array(1))[0]
  } while (rand >= range)
  return rand % max
}

// builds a default password that always satisfies the given password_requirements
// (falls back to the historical min-8-chars-plus-everything defaults if req isn't loaded yet),
// rather than a plain lowercase/digit random string that would immediately fail validation
export const generateDefaultPassword = (req) => {
  const lower = 'abcdefghijklmnopqrstuvwxyz'
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const digits = '0123456789'
  const symbols = '!@#$%^&*'
  const randomChar = (chars) => chars[secureRandomInt(chars.length)]

  const chars = [randomChar(lower)]
  if(!req || req.require_mixed_case) chars.push(randomChar(upper))
  if(!req || req.require_number) chars.push(randomChar(digits))
  if(!req || req.require_symbol) chars.push(randomChar(symbols))

  const allChars = lower + upper + digits + symbols
  const minLength = req?.min_length || 8
  while(chars.length < minLength) {
    chars.push(randomChar(allChars))
  }

  for(let i = chars.length - 1; i > 0; i--) {
    const j = secureRandomInt(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]]
  }

  return chars.join('')
}
